
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorGenericInleftBottom25 as ObiThreewayAcuatorGenericInleftBottom25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-generic-inleft-bottom-25.js';
 
 
 

 
 export const ObiThreewayAcuatorGenericInleftBottom25 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-generic-inleft-bottom-25',
   elementClass: ObiThreewayAcuatorGenericInleftBottom25Element,
   events: {
     
   }
  });
 
 